import { Component } from '@angular/core';

@Component({
  selector: 'wp-title',
  standalone: true,
  templateUrl: './title.component.html',
  styleUrl: './title.component.scss',
})
export class TitleComponent {}
